// extracted by mini-css-extract-plugin
export default {"length-script":"depends-on-script_length-script__0P5aF"};